import { Chip } from "@mui/material";
import GridListItem from "components/common/grid/GridListItem";
import React from "react";

const LaaoDevice = ({ newProfileInfo }) => {
  return (
    <GridListItem
      title="LAAO DEVICE"
      subTitle={
        newProfileInfo?.laao_device !== null ? (
          <Chip
            color={newProfileInfo?.laao_device ? "secondary" : "default"}
            label={
              <span className="d-flex align-items-center text-normal">
                {newProfileInfo?.laao_device ? "YES" : "No"}
              </span>
            }
            style={{ padding: "0px 5px", marginBottom: 5 }}
          />
        ) : (
          "—"
        )
      }
      size="3"
    />
  );
};

export default LaaoDevice;
